<template>
    <div>
        <contract-header :contract="contract"></contract-header>
        <tabs :nav-classes="['nav-tabs-linetriangle']"
              :store-module="moduleName">
        </tabs>
    </div>
</template>

<style scoped>

</style>

<script type="text/babel">
    import ContractHeader from './ContractManagementContent/ContractHeader'
    import Tabs from 'components/Tabs/Tabs'
    import { moduleName } from './ContractManagementContent/tabs'
    import * as customer from './tabs'
    import alternativeTab from 'mixins/alternativeTab'
    import routeWatcher from 'mixins/routeWatcher'
    import { mapActions, mapState, mapMutations } from 'vuex'
    import { FETCHING_SWITCH } from 'store/mutation-types'

    export default {
        name: "ContractManagement",

        mixins: [
            alternativeTab(moduleName, 'contract-management'),
            alternativeTab(customer.moduleName, 'customer', 0),
            routeWatcher("fetchContractData"),
        ],

        components: {
            Tabs,
            ContractHeader,
        },

        data () {
            return {
                moduleName,
                customerId: Number(this.$route.params.id),
                contractId: Number(this.$route.params.contractId),
            }
        },

        created () {
            this.fetchContractData()
        },

        beforeRouteUpdate () {
            this.fetchContractData()
        },

        computed: {
            ...mapState('contract', {
                contract: 'model',
                instructions: 'instructions',
            }),
            ...mapState('contract', ["fullOffers"]),

        },

        methods: {
            ...mapActions('contract', [
                'fetchContract',
                'fetchInstructions',
                'fetchForwardingAddresses',
                'fetchOptionsInstructions',
                'fetchMailWithdrawalProxies',
                'fetchSingleFullOffer'
            ]),

            ...mapMutations('contract', {
                fetchingSwitch: FETCHING_SWITCH
            }),

            fetchContractData () {
                this.fetchingSwitch()
                this.fetchContract(this.contractId)
                    .then(
                        () => Promise.all([
                            this.fetchInstructions(),
                            this.fetchOptionsInstructions(),
                            this.fetchForwardingAddresses(),
                            this.fetchMailWithdrawalProxies(),
                            this.fetchSingleFullOffer(this.contract.offer.id),
                            this.setTabsArray(this.contract)
                        ])
                    )
                    .then(this.fetchingSwitch)
            },

            setTabsArray(contract) {
                let availableTabs = [0,1]

                // Mail forward option check
                const hasMailForwarded = _.filter(contract.contract_options, co => {
                    return co.option.mail_forwarded && _.includes(['active', 'pending-termination'], co.status)
                }).length > 0

                if (hasMailForwarded) {
                    availableTabs.push(2)
                }

                // Simple hotline option check
                const hasSimpleHotline = _.filter(contract.contract_options, co => {
                    return co.option.simple_hotline && _.includes(['active', 'pending-termination'], co.status)
                }).length > 0

                if (hasSimpleHotline) {
                    availableTabs.push(3)
                }

                this.$store.state.tabs.contractManagement.available_tabs_indexes = availableTabs
            }
        },

    }
</script>



// WEBPACK FOOTER //
// client/components/Customer/ContractManagement.vue